// extracted by mini-css-extract-plugin
var _1 = "_rolesRolePermissions-module__input";
var _2 = "_rolesRolePermissions-module__permission-container";
var _3 = "_rolesRolePermissions-module__permission-input-container";
var _4 = "_rolesRolePermissions-module__permission-input-subcontainer";
var _5 = "_rolesRolePermissions-module__permission-label";
export { _1 as "input", _2 as "permission-container", _3 as "permission-input-container", _4 as "permission-input-subcontainer", _5 as "permission-label" }
